import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39c6739f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 0,
  class: "c-magic-line"
}
const _hoisted_4 = {
  key: 1,
  class: "c-magic-line"
}
const _hoisted_5 = {
  key: 1,
  class: "flex gap-x3"
}
const _hoisted_6 = {
  key: 2,
  class: "flex items-center gap-x2"
}
const _hoisted_7 = { class: "text-12 xl:text-14" }

import { computed } from 'vue';
import authStore from '@/shared/auth/auth.store';
import siteContextStore from '@/shared/content/site-context.store';
import useProfile from '@/shared/navigation/site-navigation/useProfile';
import ToggleNetPrice from '@/b2b/shared/auth/ui/ToggleNetPrice.vue';
import pageStore from '@/shared/content/page.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'CountryAndLanguageSelector',
  setup(__props) {

const { accountName, isSignedInAsPartner, hideNetPrice } = useProfile();
const localizedCountry = computed(() => siteContextStore.getLocalizedCountry());
const languages = computed(() => siteContextStore.getLanguages());
const country = computed(() => siteContextStore.getCountry());

const showCountry = computed(() => {
    return !authStore.isSignedInAsPartner;
});

const showSwitchLanguage = computed(() => {
    return !authStore.isSignedInAsPartner && !authStore.isSignedInAsStore;
});

return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(showCountry))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("a", {
            class: "text-12 xl:text-14 flex items-center gap-8",
            href: _unref(pageStore).changeCountryUrl
          }, [
            _createVNode(_component_c_icon, {
              name: "icon-map",
              class: "c-top-bar__icon w-13 h-18 flex-shrink-0"
            }),
            (_unref(localizedCountry) || _unref(country).name)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(localizedCountry) || _unref(country).name), 1))
              : (_unref(country).code === 'en')
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$dictionary.get('global/generic/international')), 1))
                : _createCommentVNode("", true)
          ], 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    (_unref(showSwitchLanguage) && _unref(languages).length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languages), (language) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(language.current ? 'span' : 'a'), {
              key: language.languageCode,
              href: language.current ? undefined : '/' + language.languageCode,
              title: language.name,
              class: _normalizeClass([{ 'c-magic-line--underline-static': language.current }, "c-magic-line text-12 xl:text-14 uppercase"])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(language.twoLetterISOLanguageName), 1)
              ]),
              _: 2
            }, 1032, ["href", "title", "class"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_unref(isSignedInAsPartner))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(accountName)), 1),
          (!_unref(hideNetPrice))
            ? (_openBlock(), _createBlock(ToggleNetPrice, {
                key: 0,
                class: "-mt-2"
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})